import React, { useEffect, useState } from 'react';
import './Interns.css';
import db from '../firebase'; // ✅ use default import
import { collection, getDocs } from 'firebase/firestore';

function Interns() {
  const [interns, setInterns] = useState([]);

  useEffect(() => {
    const fetchInterns = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'Interns'));
        const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setInterns(data);
      } catch (error) {
        console.error('Error fetching interns:', error);
      }
    };

    fetchInterns();
  }, []);

  return (
    <div className="interns-page">
      <h1>Our Interns</h1>
      <p className="intro">
        At <strong>SamSoftix</strong>, we believe in nurturing talent. Our internship program is designed to help fresh graduates build hands-on experience in real projects and gain confidence in professional settings.
      </p>

      <div className="intern-list">
        {interns.length === 0 ? (
          <p>No intern data available.</p>
        ) : (
          interns.map((intern) => (
            <div key={intern.id} className="intern-card">
              <h2>{intern.name}</h2>
              <p><strong>Joining Date:</strong> {intern.joiningDate}</p>
              <p><strong>Internship Ended At:</strong> {intern.endingDate}</p>
              <p><strong>Domain:</strong> {intern.domain}</p>

              <p><strong>Responsibilities:</strong></p>
              <ul>
                {(Array.isArray(intern.responsibilities) ? intern.responsibilities : [intern.responsibilities])
                  .filter(Boolean)
                  .map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
              </ul>

              <p><strong>Projects Done:</strong></p>
              <ul>
                {(Array.isArray(intern.projects) ? intern.projects : [intern.projects])
                  .filter(Boolean)
                  .map((project, index) => (
                    <li key={index}>{project}</li>
                  ))}
              </ul>
            </div>
          ))
        )}
      </div>
      <br/>
      <br/>
      <br/>
      <br/>
    </div>
  );
}

export default Interns;
